import React, { useContext } from 'react'
import { Trans } from '@lingui/macro'

import IconArrowRight from '../../../../components/common/icon/IconArrowRight'
import { linkBuilder } from '../../../../../../shared/linkBuilder'
import { navigateTo } from '../../../../app/util/appHistory'
import { ManageSurveyContext } from '../ManageSurveyContext'
import { LinkBox } from 'front-end/src/components'

interface ISurveysSummaryBoxesProps {
  questions: number
  recipients: number
  responses: number
}

const SurveysSummaryBoxes = ({
  questions,
  recipients,
  responses
}: ISurveysSummaryBoxesProps) => {
  const { survey } = useContext(ManageSurveyContext)

  return (
    <>
      <main className="Summary__boxes">
        <LinkBox
          className="Summary__box"
          onClick={() =>
            navigateTo(linkBuilder.surveyDetailManage(survey.id, 'create'))
          }
        >
          <div className="Summary__number">{questions}</div>
          <div className="Summary__container">
            <div className="Summary__title">
              <Trans>Questions</Trans>
            </div>
            <span className="Summary__desc">
              <Trans>Open survey designer</Trans> <IconArrowRight />
            </span>
          </div>
        </LinkBox>
        <LinkBox
          className="Summary__box"
          onClick={() =>
            navigateTo(linkBuilder.surveyDetailManage(survey.id, 'send'))
          }
        >
          <div className="Summary__number">{recipients}</div>
          <div className="Summary__container">
            <div className="Summary__title">
              <Trans>Recipients</Trans>
            </div>
            <span className="Summary__desc">
              <Trans>Send & view audience</Trans> <IconArrowRight />
            </span>
          </div>
        </LinkBox>
        <LinkBox
          className="Summary__box"
          onClick={() =>
            navigateTo(linkBuilder.surveyDetailManage(survey.id, 'results'))
          }
        >
          <div className="Summary__number">{responses}</div>
          <div className="Summary__container">
            <div className="Summary__title">
              <Trans>Responses</Trans>
            </div>
            <span className="Summary__desc">
              <Trans>Open results report</Trans> <IconArrowRight />
            </span>
          </div>
        </LinkBox>
      </main>
    </>
  )
}

export default SurveysSummaryBoxes
